import { h, render, RendererNode } from 'vue';
import IncompatibleBrowserService from './IncompatibleBrowserService.vue';

function createComponent(component: RendererNode, props: Object, parentContainer: HTMLElement, slots = {}) {
  const vNode = h(component, props, slots);
  const container = document.createElement('div');
  parentContainer.appendChild(container);
  render(vNode, container);
  return vNode.component;
}

export default {
  async install() {
    const container = document.body;
    createComponent(IncompatibleBrowserService, {}, container);
  },
};
